module.exports = __webpack_public_path__ + "img/mv04.30c82693.png";